export default {
    signin: {
      pageName: "Администратор",
      title: "Авторизация",
      userForm: {
        username: {
          placeholder: "Пользователь"
        },
        password: {
          placeholder: "Пароль"
        },
        language: {
          placeholder: "Язык"
        },
        connection: {
          placeholder: "Подключение"
        },
        signin: "Вход"
      },
      alert: "Для входа введите имя пользователя и пароль",
      userRules: {
        username: {
          required: "Необходимо ввести имя пользователя",
          min: "Имя пользователя должно быть не менее 4 символов",
          max: "Имя пользователя должно быть не более 24 символов"
        },
        password: {
          required: "Необходимо ввести пароль",
          min: "Длина пароля должна быть не менее 4 символов",
          max: "Длина пароля должна быть не более 24 символов"
        },
        language: {
          required: "Необходимо выбрать язык"
        },
        connection: {
          required: "Необходимо выбрать подключение"
        }
      }
    }
  };
  